/* ============================================================
   AŞKIM: Shop filters
   Filters and sorts the pieces already on the Shop page, the way the
   approved static site did. Nothing to switch on in the Shopify admin,
   and no page reload when a choice changes. Sold-out pieces always come
   after the ones that can be bought, whatever the sort.

   Loaded as a plain script in the browser (window.AskimFilters) and as a
   module by the tests.
   ============================================================ */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.AskimFilters = api;
})(this, function () {

  function chosen(value) { return value !== undefined && value !== null && value !== '' && value !== 'all'; }

  /* items: [{ type, colours: [..], price, available, index }]
     state: { type, colour, sort } where sort is 'featured' (the order
     given), 'price-ascending' or 'price-descending'. */
  function applyFilters(items, state) {
    state = state || {};
    var list = items.filter(function (p) {
      if (chosen(state.type) && p.type !== state.type) return false;
      if (chosen(state.colour) && p.colours.indexOf(state.colour) === -1) return false;
      return true;
    });
    var dir = state.sort === 'price-ascending' ? 1 : state.sort === 'price-descending' ? -1 : 0;
    return list.slice().sort(function (a, b) {
      if (a.available !== b.available) return a.available ? -1 : 1;
      if (dir && a.price !== b.price) return (a.price - b.price) * dir;
      return a.index - b.index;
    });
  }

  return { applyFilters: applyFilters };
});
